import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';

const vuexPersist = new VuexPersist({
  key: 'easy-dressing',
  storage: window.localStorage,
});

const store = createStore({
  state() {
    return {
      lastChosenPreset: null,
      currentConfiguration: [],
    };
  },
  mutations: {
    //--------//
    // Preset //
    //--------//
    saveChosenPreset(state, payload) {
      state.lastChosenPreset = payload.lastChosenPreset;
    },
    clearChosenPreset(state) {
      state.lastChosenPreset = null;
    },
    //--------------------//
    // User configuration //
    //--------------------//
    updateCurrentConfiguration(state, payload) {
      state.currentConfiguration = payload.currentConfiguration;
    },
    clearCurrentConfiguration(state) {
      state.currentConfiguration = [];
    },
    //
    addBox(state, payload) {
      state.currentConfiguration.push({
        position: state.currentConfiguration.length,
        color: payload.color,
        isBox: true,
        box: {
          height: payload.height,
          width: payload.width,
          color: 5, // "Blanc" (ID 5)
        },
        content: [],
      });
    },
    modifyBox(state, payload) {
      state.currentConfiguration[payload.activeBox].box[payload.parameter] = payload.value;
    },
    newContent(state, payload) {
      const element = {
        name: payload.key,
        id: state.currentConfiguration[payload.activeBox].content.length,
        height: 0.0,
        color: 5, // "Blanc" (ID 5)
      };

      state.currentConfiguration[payload.activeBox].content.push(element);
    },
    changeType(state, payload) {
      if (payload.isBox != state.currentConfiguration[payload.activeBox].isBox) {
        state.currentConfiguration[payload.activeBox].isBox = payload.isBox;

        state.currentConfiguration[payload.activeBox].content = [];
        state.currentConfiguration[payload.activeBox].box = {
          height: 194,
          width: 64,
          color: 5, // "Blanc" (ID 5)
        };
      }
    },
    setContentHeight(state, payload) {
      state.currentConfiguration[payload.activeBox].content[payload.id].height = payload.value;
    },
    removeActiveBox(state, payload) {
      state.currentConfiguration.splice(payload.activeBox, 1);

      for (let i = 0; i < state.currentConfiguration.length; i++) {
        state.currentConfiguration[i].position = i;
      }
    },
    removeAccessory(state, payload) {
      state.currentConfiguration[payload.activeBox].content.splice(payload.accessoryID, 1);

      for (let i = 0; i < state.currentConfiguration[payload.activeBox].content.length; i++) {
        state.currentConfiguration[payload.activeBox].content[i].id = i;
      }
    },
    updateGlobalColor(state, payload) {
      for (const column of state.currentConfiguration) {
        column.box.color = payload.colorID;

        for (const components of column.content) {
          components.color = payload.colorID;
        }
      }
    },
  },
  plugins: [vuexPersist.plugin],
});

export default store;
